// extracted by mini-css-extract-plugin
export default {"list":"ColorsList_list__rxEP2","item":"ColorsList_item__sTAUQ","icon":"ColorsList_icon__VHUQj"};